import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule } from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import useTrainingCourse from '@hooks/useTrainingCourse'

import TrainingCourseImageItem from './TrainingCourseImageItem/index'

interface TrainingCoursePayloadImageProps {
  trainingCoursePayload: ReturnType<typeof useTrainingCourse>,
}

const TrainingCourseImage = (props: TrainingCoursePayloadImageProps) => {
  const { trainingCoursePayload } = props
  const { loading, trainingCourse } = trainingCoursePayload

  const attachmentsPayload = useAttachments({
    filters: {
      // @ts-expect-error TS2339
      attachable_id: trainingCourse.id,
      attachable_type: 'TrainingCourse',
      attachment_type: 'course_image',
    },
    performHttpRequests: !!trainingCourse.id,
  })

  const { filteredAttachments } = attachmentsPayload
  const trainingCourseImage = filteredAttachments[0]
    || { attachable_id: trainingCourse.id, attachable_type: 'TrainingCourse', attachment_type: 'course_image' }

  const trainingCourseImageUrl = digObject(trainingCourseImage, 'links.thumb_url')
  const { file_file_name } = trainingCourseImage

  const {
    callbacks: {
      createOrEditAttachment,
    },
  } = useAttachment(trainingCourseImage)

  return (
    <DashboardModule loading={loading} title="Image">
      {!loading && (
        <TrainingCourseImageItem
          callbacks={{
            launchModalFn: createOrEditAttachment,
          }}
          fileName={file_file_name}
          imageUrl={trainingCourseImageUrl}
        />
      )}
    </DashboardModule>
  )
}

export default TrainingCourseImage
